import styled, { css } from '@eduzz/houston-styles';

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  button {
    box-sizing: border-box;
  }

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-flow: column-reverse wrap;
      justify-content: flex-start;
    }
  `}
`;

export const ContainerText = styled.div`
  padding: ${({ theme }) => ` ${theme.spacing.xxxs}`};
`;
